import { useEffect, useState } from 'react';

// Simple global ref-counted progress bus. Every startProgress() call
// must be paired with a stopProgress() — interceptors in api.ts attach
// the stop to both the fulfilled and rejected paths so aborts don't
// leak counters. We don't expose the counter itself; the bar is just
// "active vs not".
let listeners: Array<(active: boolean) => void> = [];
let counter = 0;

export function startProgress() {
  counter += 1;
  listeners.forEach(fn => fn(true));
}

export function stopProgress() {
  counter = Math.max(0, counter - 1);
  if (counter === 0) listeners.forEach(fn => fn(false));
}

export function TopProgressBar() {
  const [active, setActive] = useState(false);
  useEffect(() => {
    const fn = (a: boolean) => setActive(a);
    listeners.push(fn);
    return () => { listeners = listeners.filter(x => x !== fn); };
  }, []);
  return (
    <div
      aria-hidden
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 3, zIndex: 10000,
        background: 'linear-gradient(90deg, #3b82f6, #06b6d4, #3b82f6)',
        backgroundSize: '200% 100%',
        transform: active ? 'scaleX(1)' : 'scaleX(0)',
        transformOrigin: 'left',
        transition: active ? 'transform 8s cubic-bezier(0.1, 0.7, 0.1, 1)' : 'transform 200ms ease-out',
        opacity: active ? 1 : 0,
        pointerEvents: 'none',
        animation: active ? 'hala-progress-shimmer 1.2s linear infinite' : 'none',
      }}
    >
      <style>{`@keyframes hala-progress-shimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }`}</style>
    </div>
  );
}
